import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) return toast.error("New password must be at least 6 characters.");
    if (nw !== nw2) return toast.error("New passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated.");
      setOpen(false); setCur(""); setNw(""); setNw2("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger || <Button variant="outline" data-testid="change-password-btn" className="rounded-full border-navy/30"><KeyRound size={16} className="mr-2" />Change Password</Button>}</DialogTrigger>
      <DialogContent className="bg-cream">
        <DialogHeader><DialogTitle className="font-serif text-2xl text-navy">Change Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Current password</Label><Input type="password" required data-testid="cp-current" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1 bg-white" /></div>
          <div><Label>New password</Label><Input type="password" required minLength={6} data-testid="cp-new" value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1 bg-white" /></div>
          <div><Label>Confirm new password</Label><Input type="password" required data-testid="cp-confirm" value={nw2} onChange={(e) => setNw2(e.target.value)} className="mt-1 bg-white" /></div>
          <Button type="submit" disabled={loading} data-testid="cp-submit" className="w-full rounded-full bg-coral hover:bg-[#C95B50] text-white">{loading ? "Updating…" : "Update Password"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
